import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import { connect } from 'echarts';

let vm = null;
export function sendThis(_this) {
  vm = _this;
}

// 课程中心--课程商品
export const courseTypeData = [
  {
    value: 1,
    label: '素质课程',
    children: [
      {
        value: 11,
        label: '艺术',
        children: [],
        loading: false
      },
      {
        value: 12,
        label: '科技',
        children: [],
        loading: false
      },
      {
        value: 13,
        label: '体育',
        children: [],
        loading: false
      },
      {
        value: 14,
        label: '美术',
        children: [],
        loading: false
      },
      {
        value: 15,
        label: '综合实践',
        children: [],
        loading: false
      }
    ],
    loading: false
  },
  {
    value: 2,
    label: '托管',
    children: [
      {
        value: 21,
        label: '早托',
        children: [],
        loading: false
      },
      {
        value: 22,
        label: '午托',
        children: [],
        loading: false
      },
      {
        value: 23,
        label: '晚托',
        children: [],
        loading: false
      },
      {
        value: 24,
        label: '全托',
        children: [],
        loading: false
      }
    ],
    loading: false
  }
];
export const classTypeList = [
  { label: '全部', value: -1 },
  { label: '素质课', value: '1' },
  { label: '基础托管', value: '2' }
];

export const courseEnrollStateList = [
  { label: '全部商品状态', value: -1 },
  { label: '报名中', value: 1 },
  { label: '已报满', value: 2 },
  { label: '已截止', value: 3 },
  { label: '已下架', value: 4 },
  { label: '未开始', value: 6 }
];

export const classroomStateList = [
  { label: '全部上架状态', value: -1 },
  { label: '已上架', value: 4 },
  { label: '已下架', value: 0 }
];

export const nameList = [
  { label: '商品名称', value: 'classroomName' },
  { label: '商品ID', value: 'classroomId' },
  { label: '资源名称', value: 'courseName' }
  // { label: '资源ID', value: 'courseId' }
];

export const selectArr = [
  key(null, null, tableColumnsWidth.type1, {
    type: 'selection',
    fixed: 'left'
  })
];
export const operatorArr = [
  slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
];
export const columns = [
  key(null, null, tableColumnsWidth.type1, {
    type: 'selection',
    fixed: 'left'
  }),
  key('商品ID', 'classroomId', tableColumnsWidth.type4, {
    fixed: 'left'
  }),
  slot('课程商品名', 'classroomName', tableColumnsWidth.type6, {
    fixed: 'left'
  }),
  slot('学校', 'schoolName', tableColumnsWidth.type6, {
    fixed: 'left'
  }),
  slot('课程类别', 'courseTypeKind', tableColumnsWidth.type2, {
    align: 'center'
  }),
  key('学期', 'termName', tableColumnsWidth.type4),
  // key('校区', 'schBranchName', tableColumnsWidth.type6),
  slot('课程资源名', 'courseName', tableColumnsWidth.type6),
  slot('提供方', 'orgName', tableColumnsWidth.type6),
  slot('可报人数', 'studentTotal', 100, {
    align: 'center'
  }),
  // key('报名人数', 'registeredNumbers', tableColumnsWidth.type3),
  key('报名人数', 'registeredNumbers', tableColumnsWidth.type8, {
    renderHeader: (h, params) => {
      const handleFilterNums = () => {
        vm.handleShowMemberModal();
      };
      return h(
        'div',
        {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        },
        [
          h('span', ['报名人数']),
          h('Icon', {
            on: {
              // 单元格的点击事件
              click: handleFilterNums
            },
            style: { marginLeft: '8px', cursor: 'pointer' },
            props: {
              type: 'ios-search',
              size: 24,
              color: '#ccc'
            }
          })
        ]
      );
    },
    align: 'center'
  }),
  slot('课程显示价格（元）', 'courseDisplayPrice', tableColumnsWidth.type5, {
    align: 'center'
  }),
  slot('价格（元）', 'classroomFee', tableColumnsWidth.type9, {
    align: 'center'
  }),
  key('累计课时', 'classroomTotal', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('预计上课时间', 'timeDesc', tableColumnsWidth.type4),
  slot('关联材料商品', 'courseClassMaterialListStr', 150),
  slot('商品状态', 'courseEnrollState', tableColumnsWidth.type2, {
    align: 'center'
  }),
  key('报名范围', 'isLimitEnrollStr', tableColumnsWidth.type3),
  slot('是否预报名', 'isPreEnroll', 110, { align: 'center' }),
  slot('列表可见', 'visibleType', tableColumnsWidth.type2, { align: 'center' }),
  slot('上架状态', 'classroomState', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('分账规则名称', 'itemName', tableColumnsWidth.type6),
  slot('是否允许退款', 'enableRefund', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('退款截止时间', 'refundDeadLine', tableColumnsWidth.type4),
  key('报名开始日期', 'enrollTimeBegin', tableColumnsWidth.type4),
  key('报名截止日期', 'enrollTimeEnd', tableColumnsWidth.type4),
  key('课程创建时间', 'createTime', tableColumnsWidth.type4),
  slot('操作', 'action', tableColumnsWidth.type6, { fixed: 'right' })
];
